<template lang="pug">
div
    listData
    addListBtn
</template>

<script>
import listData from "@/components/childComponents/ListData.vue";
import addListBtn from "@/components/childComponents/addListBtn.vue";

export default {
  components: {
    listData,
    addListBtn,
  },
};
</script>

<style lang="scss"></style>
